

















































































































































































import { AppointmentApi } from '@/api/appointments';
import { ClientAccountsApi } from '@/api/client-accounts';
import { AppointmentListRequestFilters } from '@/api/requests/appointments/appointment-list-request-filters';
import { Forbidden } from '@/api/responses/forbidden';
import appointmentList from '@/components/appointments/appointment-list.vue';
import bookAppointmentDialog from '@/components/appointments/book-appointment-dialog.vue';
import completeAppointmentDialog from '@/components/appointments/complete-appointment/complete-appointment-dialog.vue';
import editAppointmentOutcomeDialog from '@/components/appointments/edit-appointment-outcome-dialog.vue';
import editAppointmentOutcomeLegacyDialog from '@/components/appointments/edit-appointment-outcome-legacy-dialog.vue';
import viewAppointmentDialog from '@/components/appointments/view-appointment-dialog.vue';
import loading from '@/components/loading.vue';
import { Appointment } from '@/shared/appointments/appointment';
import { ClientAccount } from '@/shared/clients/client-account';
import { LocationType } from '@/shared/location-type';
import { PartnerPractice } from '@/shared/partner-practice';
import { User } from '@/shared/user';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const userModule = namespace('user');

const appointmentApi = new AppointmentApi();
const clientAccountApi = new ClientAccountsApi();

@Component({
    components: {
        appointmentList,
        bookAppointmentDialog,
        completeAppointmentDialog,
        editAppointmentOutcomeDialog,
        editAppointmentOutcomeLegacyDialog,
        viewAppointmentDialog,
        loading,
    },
})
export default class DashboardAppointment extends Vue {
    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;
    @userModule.Getter('user') private currentUser!: User;

    private isLoading: boolean = true;
    private appointments: Array<Appointment> = new Array<Appointment>();
    private partnerPracticeFilter: string | null = null;
    private accountNoFilter: number | null = null;
    private clientFirstNameFilter: string | null = null;
    private clientLastNameFilter: string | null = null;
    private locationTypeFilter: number | null = null;
    private addressFilter: string | null = null;
    private appointmentDatePeriodFilter: number | null = 0;
    private appointmentDateFromFilter: string | Date | null = null;
    private appointmentDateToFilter: string | Date | null = null;
    private appointmentStatusFilter: number = 1;
    private appointmentOutcomeFilter: number | null = null;
    private paymentStatusFilter: number | null = null;
    private selectedAppointment: Appointment | null = null;
    private selectedAppointmentClient: ClientAccount | null = null;
    private viewDialogVisible: boolean = false;
    private bookDialogVisible: boolean = false;
    private completeDialogVisible: boolean = false;
    private editOutcomeDialogVisible: boolean = false;
    private editOutcomeLegacyDialogVisible: boolean = false;
    private deleteAppointmentConfirmationDialogVisible: boolean = false;
    private deleteOutcomeConfirmationDialogVisible: boolean = false;
    private isAppointmentRebook: boolean = false;
    private isAppointmentEdit: boolean = false;
    private showProductTabs: boolean = false;

    private locationTypes = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'Office' },
        { id: 1, value: 'Home' },
        { id: 2, value: 'Telephone' },
        { id: 3, value: 'Video' },
    ]);

    private datePeriods = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'Current Day' },
        { id: 1, value: 'Current Week' },
        { id: 2, value: 'Previous Week' },
        { id: 3, value: 'Current Month' },
        { id: 4, value: 'Previous Month' },
        { id: 5, value: 'Current Quarter' },
        { id: 6, value: 'Previous Quarter' },
        { id: 7, value: 'Current Year' },
        { id: 8, value: 'Previous Year' },
        { id: 9, value: 'Custom Dates' },
    ]);

    private statusTypes = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'Pending' },
        { id: 1, value: 'Incomplete' },
    ]);

    private outcomeTypes = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'No Show' },
        { id: 1, value: 'Cancelled' },
        { id: 2, value: 'Re-booked' },
        { id: 3, value: 'Considering Options' },
        { id: 4, value: '14 Day Cooling Off Period' },
        { id: 5, value: 'Instructed' },
        { id: 6, value: 'Didn\'t Instruct' },
    ]);

    private paymentStatuses = new Array<{ id: number, value: string }>(...[
        { id: 0, value: 'Signing Pending' },
        { id: 1, value: 'Signing Booked' },
        { id: 2, value: 'Debtor' },
        { id: 3, value: 'No Longer Proceeding' },
        { id: 4, value: 'Written Off' },
        { id: 5, value: 'Part Payment' },
        { id: 6, value: 'Banked' },
        { id: 7, value: 'Cleared' },
    ]);

    private get showAddressFilter(): boolean {
        return this.locationTypeFilter === LocationType.Office || this.locationTypeFilter === LocationType.Home;
    }

    private get isCustomDatePeriod(): boolean {
        return this.appointmentDatePeriodFilter === 9;
    }

    private async showViewDialog(appointment: Appointment): Promise<void> {
        this.selectedAppointment = appointment;
        this.viewDialogVisible = true;
    }

    private async showRebookDialog(appointment: Appointment): Promise<void> {
        this.selectedAppointment = appointment;
        this.selectedAppointmentClient = await clientAccountApi.getClientAccountByIdAsync(appointment.clients[0].id!);
        this.isAppointmentRebook = true;
        this.bookDialogVisible = true;
    }

    private async showEditDialog(appointment: Appointment): Promise<void> {
        this.selectedAppointment = appointment;
        this.isAppointmentEdit = true;
        this.bookDialogVisible = true;
    }

    private async showCompletionDialog(appointment: Appointment): Promise<void> {
        this.selectedAppointment = appointment;
        this.completeDialogVisible = true;
    }

    private async showEditOutcomeDialog(appointment: Appointment): Promise<void> {
        this.selectedAppointment = appointment;

        if (appointment.outcome == null) {
            return;
        }

        if (appointment.outcome.isLegacy) {
            this.editOutcomeLegacyDialogVisible = true;
            return;
        }

        this.showProductTabs = appointment.outcome.products != null && appointment.outcome.products.length > 0;
        this.editOutcomeDialogVisible = true;
    }

    private async showDeleteAppointmentDialog(appointment: Appointment): Promise<void> {
        this.selectedAppointment = appointment;
        this.deleteAppointmentConfirmationDialogVisible = true;
    }

    private async showDeleteOutcomeDialog(appointment: Appointment): Promise<void> {
        this.selectedAppointment = appointment;
        this.deleteOutcomeConfirmationDialogVisible = true;
    }

    private onCancel(): void {
        this.selectedAppointment = null;
        this.selectedAppointmentClient = null;
        this.deleteAppointmentConfirmationDialogVisible = false;
        this.deleteOutcomeConfirmationDialogVisible = false;
        this.bookDialogVisible = false;
        this.viewDialogVisible = false;
        this.completeDialogVisible = false;
        this.editOutcomeDialogVisible = false;
        this.editOutcomeLegacyDialogVisible = false;
        this.isAppointmentRebook = false;
        this.isAppointmentEdit = false;
    }

    private onAppointmentBooked(): void {
        if (this.isAppointmentEdit) {
            this.$snackbar.open({ message: `Appointment successfully updated`, type: 'is-success' });
        } else {
            this.$snackbar.open({ message: `Appointment successfully re-booked`, type: 'is-success' });
        }

        this.onCancel();
        this.reloadAppointments();
    }

    private onCompleted(): void {
        this.$snackbar.open({ message: `Appointment successfully completed`, type: 'is-success' });
        this.onCancel();
        this.reloadAppointments();
    }

    private onOutcomeChanged(): void {
        this.$snackbar.open({ message: `Appointment outcome successfully updated`, type: 'is-success' });
        this.onCancel();
        this.reloadAppointments();
    }

    private async onDeleteAppointment(): Promise<void> {
        try {
            await appointmentApi.deleteAppointmentAsync(this.selectedAppointment!);
            await this.reloadAppointments();
        } catch (e) {
            this.$snackbar.open({ message: 'Could not delete appointment, please try again.', type: 'is-danger' });
        }
        this.onCancel();
    }

    private async onDeleteOutcome(): Promise<void> {
        try {
            await appointmentApi.deleteAppointmentOutcomeAsync(this.selectedAppointment!);
            await this.reloadAppointments();
        } catch (e) {
            this.$snackbar.open({ message: 'Could not delete appointment outcome, please try again.', type: 'is-danger' });
        }
        this.onCancel();
    }

    private async fetchAllAppointmentsAsync(): Promise<void> {
        try {
            const filters: AppointmentListRequestFilters = {
                partnerPracticeId: this.partnerPractices.length === 1 ? this.partnerPractices[0].id! : this.partnerPracticeFilter,
                accountNumber: this.accountNoFilter,
                clientFirstName: this.clientFirstNameFilter,
                clientLastName: this.clientLastNameFilter,
                legalAdvisorId: this.currentUser.id!,
                locationType: this.locationTypeFilter,
                address: this.showAddressFilter ? this.addressFilter : null,
                appointmentDatePeriod: this.appointmentDatePeriodFilter,
                appointmentDateFrom: this.appointmentDateFromFilter,
                appointmentDateTo: this.appointmentDateToFilter,
                appointmentStatus: this.appointmentStatusFilter,
                appointmentOutcome: this.appointmentOutcomeFilter,
                paymentStatus: this.paymentStatusFilter,
            };

            this.appointments = await appointmentApi.getAppointmentsAsync(filters);
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not load appointments, please try again.', type: 'is-danger' });
            }
        }
    }

    private async reloadAppointments(): Promise<void> {
        if (!(await this.$validator.validateAll())) {
            return;
        }

        this.isLoading = true;
        await this.fetchAllAppointmentsAsync();
        this.isLoading = false;
    }

    private clearFilters(): void {
        this.partnerPracticeFilter = null;
        this.accountNoFilter = null;
        this.clientFirstNameFilter = null;
        this.clientLastNameFilter = null;
        this.locationTypeFilter = null;
        this.addressFilter = null;
        this.appointmentDatePeriodFilter = 0;
        this.appointmentDateFromFilter = null;
        this.appointmentDateToFilter = null;
        this.appointmentStatusFilter = 1;
        this.appointmentOutcomeFilter = null;
        this.paymentStatusFilter = null;
    }

    private async mounted(): Promise<void> {

        this.isLoading = true;

        await Promise.all([
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`users/loadRolesAsync`),
            this.$store.dispatch(`users/loadAllUsersAsync`),
        ]);

        if (this.partnerPractices.length === 1) {
            await this.fetchAllAppointmentsAsync();
        }

        this.isLoading = false;
    }
}
